import { Loader2 } from 'lucide-react';

import { AlertDialog, AlertDialogContent, AlertDialogTitle } from '../UI/AlertDialog';

const LoadingBackdrop = ({
  showBackdrop: toggleBackdrop = false
}: {
  showBackdrop: boolean;
}) => (
  <AlertDialog open={toggleBackdrop}>
    <AlertDialogContent className="max-w-[100px]">
      <AlertDialogTitle className="text-center">
        <Loader2 className="mx-auto size-6 animate-spin" />
        <span className="sr-only">Loading...</span>
      </AlertDialogTitle>
    </AlertDialogContent>
  </AlertDialog>
);

export default LoadingBackdrop;
